module.exports = __webpack_public_path__ + "img/pir-brick-horizontal.6f8ee8b2.svg";